/*
 * brd-2026-social-proof.js
 * Per-section Swiper bootstrap for the reviews / social proof strip.
 */
(function () {
  'use strict';

  function whenSwiperReady(cb, attempt) {
    attempt = attempt || 0;
    if (typeof window.Swiper === 'function') return cb();
    if (attempt > 200) return;
    setTimeout(function () { whenSwiperReady(cb, attempt + 1); }, 50);
  }

  /**
   * Wire up the read-more / read-less toggle on any long review quotes
   * inside `root`. Runs once per section. Each toggle swaps two spans
   * (preview + full richtext) via the `hidden` attribute; the button's
   * inner labels (`.toggle-more` / `.toggle-less`) flip the same way.
   *
   * After each toggle we call the Swiper's `updateAutoHeight()` so the
   * slide container grows/shrinks to fit the new content — without this
   * step, expanded text can overflow into neighbouring slides.
   */
  function initReadMoreToggles(root, swiperInstance) {
    var toggles = root.querySelectorAll('[data-brd-quote-toggle]');
    Array.prototype.forEach.call(toggles, function (btn) {
      btn.addEventListener('click', function () {
        var wrap    = btn.closest('[data-brd-truncatable]');
        if (!wrap) return;
        var preview = wrap.querySelector('[data-brd-quote-preview]');
        var full    = wrap.querySelector('[data-brd-quote-full]');
        var moreLbl = btn.querySelector('[data-brd-toggle-more]');
        var lessLbl = btn.querySelector('[data-brd-toggle-less]');

        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          preview.hidden = false;
          full.hidden    = true;
          moreLbl.hidden = false;
          lessLbl.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          preview.hidden = true;
          full.hidden    = false;
          moreLbl.hidden = true;
          lessLbl.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }

        // Since we're not using autoHeight anymore, container height is
        // driven purely by CSS — the swiper root uses `height: auto` and
        // grows naturally. We still call update() so Swiper re-checks
        // slide positions, but no height math needs to happen here.
        if (swiperInstance && typeof swiperInstance.update === 'function') {
          requestAnimationFrame(function () {
            swiperInstance.update();
          });
        }
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.brdSpInit === '1') return;

    whenSwiperReady(function () {
      var swiperEl = root.querySelector('.brd-social-swiper');
      if (!swiperEl) return;

      var perDesktop = parseInt(root.dataset.perDesktop, 10) || 3;
      var showArrows = root.dataset.showArrows === 'true';
      var showDots   = root.dataset.showDots === 'true';

      var instance = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 24,
        watchOverflow: true,
        // NOTE: intentionally NOT using `autoHeight`. Swiper's autoHeight
        // sets an inline pixel `height` on the swiper container, measured
        // at initial mount from the active slide's height. When a review
        // is later expanded via the read-more toggle, that inline height
        // becomes stale and clips the expanded content. Calling
        // updateAutoHeight() after the toggle races the browser's reflow
        // and often measures the old height. Instead we let CSS decide
        // container height (`height: auto` on `.swiper` + wrapper), so
        // the container naturally grows to fit whichever slide is
        // currently rendering — including expanded ones.
        breakpoints: {
          750:  { slidesPerView: Math.max(2, perDesktop - 1), spaceBetween: 32 },
          1100: { slidesPerView: perDesktop,                  spaceBetween: 40 }
        },
        navigation: showArrows ? {
          nextEl: root.querySelector('.brd-social__arrow--next'),
          prevEl: root.querySelector('.brd-social__arrow--prev')
        } : false,
        pagination: showDots ? {
          el: root.querySelector('.swiper-pagination'),
          clickable: true
        } : false,
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous review',
          nextSlideMessage: 'Next review'
        }
      });

      swiperEl.brdSwiper = instance;

      // Wire the read-more/read-less toggles now that Swiper is ready —
      // the swiperInstance is passed in so each toggle can request an
      // updateAutoHeight() call after it flips content visibility.
      initReadMoreToggles(root, instance);

      root.dataset.brdSpInit = '1';
    });
  }

  function bootAll() {
    document.querySelectorAll('.brd-social[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.brd-social[data-section-id]');
    if (s) init(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target.querySelector('.brd-social[data-section-id]');
    if (!s) return;
    var swiperEl = s.querySelector('.brd-social-swiper');
    if (swiperEl && swiperEl.brdSwiper && typeof swiperEl.brdSwiper.destroy === 'function') {
      swiperEl.brdSwiper.destroy(true, true);
      swiperEl.brdSwiper = null;
    }
  });
})();
